import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { loadStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { Observable } from 'rxjs';
import { HubFrequentDriverListFacade } from './hub-frequent-driver-list.facade';

@Injectable({
  providedIn: 'root',
})
export class HubFrequentDriverListGuard {
  constructor(private hubFrequentDriverListFacade: HubFrequentDriverListFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { hubId },
    } = route;
    return loadStoreState(this.hubFrequentDriverListFacade, hubId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.hubFrequentDriverListFacade);
  }
}
